<template>
<div class="around">
    <div id="map"></div>
    <div class="around-list"
        :class="{ 'in-transition': inTransition }"
        :style="{ transform: iphoneX ? `translateY(${translateY - 34}px)`: `translateY(${translateY}px)`, height: 'calc(100vh - 140px)' }"
        @transitionend="handleTransitionEnd"
        @transitioncancel="handleTransitionEnd">
        <div class="move-trigger"
            ref="trigger"
            @touchstart="handleTouchStart"
            @touchmove="handleTouchMove"
            @touchend="handleTouchEnd"
            @touchcancel="handleTouchEnd">
            <div class="line"></div>
            <!--tab-->
            <div class="tab-nav">
                <div class="tab-item"
                    :class="{ 'active': tabIndex === index }"
                    v-for="(item, index) in tabs"
                    :key="item.name"
                    @click.stop="selectTab(index)">{{item.name}}</div>
            </div>
        </div>
        <div class="current-locate" @click="locateUser">
            <img src="../assets/zoom-in-orange.svg" alt="" v-if="showLocateMarker">
            <img src="../assets/zoom-in.svg" alt="" v-else>
        </div>
        <cube-scroll ref="scroll"
                    :scroll-events="['scroll']"
                    @scroll="handleScroll"
                    :options="options"
                    @pulling-up="handleMore"
                    :style="{maxHeight: scrollHeight}"
                    :data="list"
                    class="horizontal-scroll-list-wrap">
            <v-loading class="tab-loading" v-if="tabLoading" />
            <!--景区列表-->
            <div class="scenic-list-container">
                <!-------------------列表(多状态)-------------------->
                <div class="list-contain">
                    <!--列表结果-->
                    <div v-if="finished">
                        <v-card :list="list"
                                :category="tabs[tabIndex].model"
                                @detail="handleCardTap" />
                        <div v-if="empty" class="empty-tip">
                            <img src="/image/no-data.png" />
                            <div class="text">更多内容即将上线</div>
                            <div class="text">敬请期待</div>
                        </div>
                    </div>
                </div>
            </div>
            <template slot="pullup" slot-scope="props">
                <div class="down-loading">
                    <v-loading loadType="down" v-if="props.isPullUpLoad"></v-loading>
                    <div class="no-more" v-else-if="!props.beforePullDown">没有更多了</div>
                </div>
            </template>
        </cube-scroll>
    </div>
    <div v-show="popupDetail.id">
        <div class="popup" ref="popup" @click="handleDetail">
            <div class="img-container">
                <img v-if="popupDetail.images && popupDetail.images.length > 0"
                        v-lazy="generateObj(popupDetail.images[0].image)"/>
                <img v-else-if="popupDetail.image" v-lazy="generateObj(popupDetail.image)"/>
                <img v-else v-lazy="generateObj(popupDetail.image_url)"/>
            </div>
            <div class="popup-detail">
                <div class="popup-name">{{ popupDetail.name }}</div>
                <div class="popup-tags"
                        v-if="popupDetail.labels && popupDetail.labels.length > 0 && popupDetail.type !== 'show_item'">
                    <div class="tag" v-for="item in popupDetail.labels" :key="item">{{ item }}</div>
                </div>
                <div class="popup-ticket" v-if="popupDetail.type === 'show_item'">
                    <span v-if="popupDetail.ticket_type === 'supported' && popupDetail.best_price !== null">门票: {{ siteId === '1' ? 'S$' : '¥'
                        }}{{ popupDetail.best_price / 100 }}{{ siteId !== '1' ? '元' : '' }}起</span>
                    <span v-else-if="popupDetail.ticket_type === 'unsupported' && popupDetail.low_price !== null">门票: {{ siteId === '1' ? 'S$' : '¥'
                        }}{{ popupDetail.low_price / 100 }}{{ siteId !== '1' ? '元' : '' }}起</span>
                    <span v-else>门票: 免费</span>
                </div>
                <div class="popup-time promotion"
                        v-if="popupDetail.type === 'show_item' || popupDetail.type === 'poi_promotion'">
                    {{ popupDetail.time }}
                </div>
                <div class="place-rate"
                        v-if="popupDetail.rating && (popupDetail.type !== 'show_item' && popupDetail.type !== 'shop_activity' && popupDetail.type !== 'site_shop')">
                    <Score :rating="popupDetail.rating"/>
                    <div class="place-review" v-if="popupDetail.reviews">{{ popupDetail.reviews }} 评论</div>
                </div>
            </div>
            <div class="popup-btns"
                    :class="{ 'with-audio' : popupDetail.audio_files && popupDetail.audio_files.length > 0 }">
                <div class="play-btn"
                        @click.stop="handleJieshuo"
                        v-if="(popupDetail.type === 'site' || popupDetail.type === 'subsite') && popupDetail.audio_files && popupDetail.audio_files.length > 0">
                    <img src="/image/map-jieshuo.png"/>
                </div>
                <div class="navigate-icon" @click.stop="handleNavigate">
                    <img v-if="siteId==='1'" src="/image/map-navigate-sentosa.png"/>
                    <img v-else src="/image/map-navigate.png"/>
                </div>
            </div>
        </div>
    </div>
    <div class="current-marker" ref="marker">
        <div class="circle">
            <div class="arrow"></div>
        </div>
    </div>
</div>
</template>

<script>
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'
import { getMapList } from '@/fetch/api'
import { clamp as _clamp } from "lodash";
import Card from '@/components/around/AroundCard'
import Loading from '@/components/Loading'
import Score from '@/components/Score'
import {pointWithinThere} from '@/utils/index'

export default {
    data () {
        return {
            tabLoading: false,
            currentPage: 1,
            list: [],
            totalPages: 0,
            finished: true,
            tabIndex: 0,
            empty: false,
            tabs: [
                // {"name": "优惠", "model": "poi_promotion"},
                { name: "景点", model: "site" },
                // {"name": "住宿", "model": "hotel"},
                { name: "美食", model: "merchant" },
                { name: "购物", model: "site_shop" },
                { name: "演出", model: "show_item" },
                { name: "活动", model: "site_activity" }
            ],
            modelMap: {
                'site': 'Site',
                'merchant': 'Merchant',
                'site_shop': 'SiteShop',
                'show_item': 'ShowItem',
                'site_activity': 'SiteActivity'
            },
            networkError: false,
            hold: false,
            startY: 0,
            lastTouch: {
                y: 0,
                t: 0
            },
            inThere: false,
            startGeo: {},
            speed: 0,
            translateY: 0,
            inTransition: false,
            expand: false,
            scrollTop: 0,
            iphoneX: false,
            options: {
                pullUpLoad: {
                    threshold: 40
                }
            },
            popupDetail: {},
            showLocateMarker: false,
            scrollHeight: ''
        }
    },
    computed: {
        siteId () {
            return this.$store.state.siteId
        }
    },
    components: {
        'v-card': Card,
        'v-loading': Loading,
        Score
    },
    created () {
        this.showPage = false
        this.boundBottom = window.innerHeight / 2 + 30
        this.startUpdateLocation()
        this.position = 'middle' // 初始状态列表在中间
        this.bottom = window.innerHeight / 2 + 60
        this.getData()
        this.oldLayer = null
        this.bearing = 0
        this.Android = window.navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
    },
    mounted () {
        mapboxgl.accessToken = 'pk.eyJ1IjoicHVzaGlhbiIsImEiOiJjaXdyaXptNDAweG1rMm90YmRnZHl0dDFpIn0.9kBN2eXNRe3uZ9VMoMhfhg'
        const center = [103.82740222, 1.2527583]
        const zoom = 12.6
        this.map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/pushian/cj8313byya3lp2so6gvh49efn',
            center,
            zoom
            // bounds: new mapboxgl.LngLatBounds([103.852152, 1.260704], [103.804682, 1.267034])
        })

        // Add geolocate control to the map.
        this.geoControl = new mapboxgl.GeolocateControl({
            trackUserLocation: true
        })

        // 根据zoom设置透明度
        this.map.on('zoom', () => {
            this.changeOpacity()
        })
        this.map.on('rotate', res => {
            const alpha = this.map.getBearing()
            console.log('=======rotateend', alpha)
            this.bearing = alpha
            // // console.log('停止旋转')
            // const marker = document.querySelector('.current-marker .circle')
            // marker.style.transform = `rotateZ(${this.markerBearning - this.bearing}deg)`
        })
    },
    methods: {
        generateObj (src) {
            let url = '/image/default_img.jpg'
            if (this.siteId === '245'|| this.siteId === '129') {
                url = '/image/rws_default.jpg'
            } else if (this.siteId === '33') {
                url = '/image/default_porsche.jpg'
            }
            return {
                src,
                error: url,
                loading: '/image/loading-img.jpg'
            }
        },
        //---------------------tab
        selectTab(index){
            console.log('点击了tab')
            if (this.popup && this.popup.isOpen) {
                this.popup.remove()
            }
            this.tabIndex = index
            let val = this.tabs[index].model
            this.$refs.scroll.scrollTo(0, 0)
            this.finished = true
            this.empty = false
            this.tabLoading = true
            //上拉
            this.currentPage = 1
            this.getData()
        },
        getData(){
            if (!this.showPage) {
                this.toast = this.$createToast({
                    time: 0,
                    txt: '加载中...',
                    mask: true
                })
                this.toast.show()
            }
            //参数(onload和筛选时page都为1)
            const params = {
                page: 1
            }
            let activeTab = this.tabs[this.tabIndex].model
            getMapList({ page: 1 }, activeTab).then(res => {
                let activeArr = res.sites || res.merchants || res.show_items || res.site_shops || res.site_activities
                //----------------------显示空
                if (activeArr.length === 0) {
                    this.empty = true
                }
                this.tabLoading = false,
                this.totalPages = res.pagination ? res.pagination.total_pages : 1
                this.list = activeArr
                this.networkError = false
                this.$nextTick(() => {
                    this.renderLayer()
                    const height = this.$refs.trigger.clientHeight
                    console.log(height)
                    this.triggerHeight = height
                    if (!this.showPage) {
                        this.toast.hide()
                        this.showPage = true
                        this.scrollHeight = `calc(100vh - ${height}px)`
                    }
                })
            }).catch(err => {
                this.finished = false
                this.empty = true
                this.currentPage = 1
                this.networkError = true
            })
        },
        handleMore () {
            console.log('上啦')
            if (this.totalPages <= this.currentPage) {
                this.$refs.scroll.forceUpdate()
                return
            }
            console.log('上啦加载更多')
            let activeTab = this.tabs[this.tabIndex].model
            getMapList({ page: this.currentPage + 1 }, activeTab).then(res => {
                let arr = res.sites || res.merchants || res.show_items || res.site_shops || res.site_activities
                this.currentPage = this.currentPage + 1
                this.list = this.list.concat(arr)
                this.$refs.scroll.forceUpdate()
                this.$nextTick(() => {
                    this.renderLayer()
                })
            })
        },
        calcData (zoom) {
            let minSize = 0.26
            let maxSize = 0.4
            let rate = 0.04
            if (this.siteId === '33') {
                minSize = 0.36
                maxSize = 0.5
                rate = 0.08
            }
            let opacity = zoom * 0.1 - 0.5
            let size = zoom * rate - 0.1

            if (size < minSize) {
                size = minSize
            } else if (size > maxSize) {
                size = maxSize
            }
            if (opacity > 1) {
                opacity = 1
            } else if (opacity < 0.7) {
                opacity = 0.7
            }
            return {
                opacity,
                size
            }
        },
        downLoadImage (url, name) {
            return new Promise((resolve, reject) => {
                if (!this.map.hasImage(name)) {
                    this.map.loadImage(url, (error, image) => {
                        console.log(error, image)
                        if (error) {
                            reject(error)
                        } else {
                            this.map.addImage(name, image)
                            resolve()
                        }
                    })
                } else {
                    resolve()
                }
            })
        },
        // 在地图上绘制列表
        renderLayer () {
            // 清除旧的layer
            if (this.oldLayer && this.map.getLayer(this.oldLayer)) {
                console.log('有旧的涂层')
                this.map.removeLayer(this.oldLayer)
                this.map.removeSource(this.oldLayer)
            }
            let zoom = 12.6
            const renderData = this.calcData(zoom)
            const currentModel = this.tabs[this.tabIndex].model
            this.downLoadImage(`/image/map/${this.modelMap[currentModel]}.png`, currentModel).then(() => {
                const features = this.list.map((item, index) => {
                    return {
                        type: 'Feature',
                        properties: {
                            poiIndex: index
                        },
                        geometry: {
                            type: 'Point',
                            coordinates: [item.lon, item.lat]
                        }
                    }
                })

                this.map.addLayer({
                    id: currentModel,
                    type: 'symbol',
                    source: {
                        type: 'geojson',
                        data: {
                            type: 'FeatureCollection',
                            features: features
                        }
                    },
                    layout: {
                        'icon-image': currentModel,
                        'icon-size': renderData.size,
                        'icon-anchor': currentModel === 'site_image' ? 'bottom' : 'center'
                    }
                })
                console.log('距离底部高度', this.boundBottom)
                if (this.list.length > 0) {
                    const bounds = this.calcLonLat()
                    this.map.fitBounds(bounds, {
                        padding: {
                            top: 30,
                            bottom: this.boundBottom,
                            left: 60,
                            right: 60
                        }
                    })
                }
                // 点击layer显示popup
                this.map.setPaintProperty(currentModel, 'icon-opacity', renderData.opacity)
                this.map.on('click', currentModel, e => {
                    const feature = e.features[0]
                    const lngLat = e.lngLat
                    const poiIndex = parseInt(feature.properties.poiIndex)
                    const currentPoi = this.list[poiIndex]
                    if (currentModel === 'site_image') { // 360全景图片直击跳转详情页面
                        window.wx.miniProgram.navigateTo({
                            url: `/packageScenic/pages/360Image/index?name=${currentPoi.name}&url=${currentPoi.image_url}`
                        })
                    } else {
                        this.popupDetail = {...currentPoi, type: currentModel}
                        this.$nextTick(() => {
                            this.initPopup(feature, lngLat)
                        })
                    }
                })
                this.oldLayer = currentModel
            })
        },
        // init popup
        initPopup (feature, lngLat) {
            console.log('点击弹窗触发', feature)
            if (this.popup && this.popup.isOpen) {
                this.popup.remove()
            }
            const coordinates = feature.geometry.coordinates.slice()

            while (Math.abs(lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += lngLat.lng > coordinates[0] ? 360 : -360
            }

            this.popup = new mapboxgl.Popup()
                .setLngLat(coordinates)
                .setDOMContent(this.$refs.popup)
                .addTo(this.map)

            this.map.flyTo({center: feature.geometry.coordinates})
        },
        handleCardTap (index) {
            this.toBottom(300)
            const poi = this.list[index]
            this.popupDetail = {
                ...poi,
                type: this.tabs[this.tabIndex].model
            }
            this.$nextTick(() => {
                this.initPopup({
                    geometry: {
                        coordinates: [poi.lon, poi.lat]
                    }
                }, {lon: poi.lon, lat: poi.lat})
            })
        },
        // 点击导航按钮
        handleNavigate () {
            // [start_lon, start_lat, start_name, start_type, start_id, end_lon, end_lat, end_name, end_type, end_id, longitude, latitude]
            let routeArray = []
            const endType = this.popupDetail.type.split('_').map(item => {
                const type = item.slice(0, 1).toUpperCase() + item.slice(1)
                return type
            }).join('')
            if (this.inThere) {
                routeArray = ['', '', '', '', '', parseFloat(this.popupDetail.lon), parseFloat(this.popupDetail.lat), this.popupDetail.name, endType, this.popupDetail.id]
            } else {
                routeArray = ['', '', '', '', '', parseFloat(this.popupDetail.lon), parseFloat(this.popupDetail.lat), this.popupDetail.name, endType, this.popupDetail.id]
            }
            window.wx.miniProgram.navigateTo({
                url: `/packageTourGuide/map/navigationMapPage/index?data=${encodeURIComponent(JSON.stringify(routeArray))}`
            })
        },
        // 获取角度、位置信息
        startUpdateLocation () {
            if (this.Android) {
                window.addEventListener('deviceorientationabsolute', this.handleOrientationAbsolute)
            } else {
                window.addEventListener('deviceorientation', this.handleOrientation)
            }
            this.watchId = window.navigator.geolocation.watchPosition((res) => {
                // console.log(longitude, latitude)
                const longitude = res.coords.longitude
                const latitude = res.coords.latitude
                const inThere = pointWithinThere(longitude, latitude)
                if (inThere && this.startGeo && !this.startGeo.lon) { // 在圣淘沙并且第一次获取到位置
                    this.inThere = true
                    this.map.flyTo({
                        center: [longitude, latitude],
                        zoom: 15
                    })
                    if (!this.currentMarker) {
                        this.drawCurrentMarker(longitude, latitude)
                    }
                }
                if (longitude) {
                    this.startGeo = {
                        lon: longitude,
                        lat: latitude
                    }
                    if (this.currentMarker) {
                        this.currentMarker.setLngLat([longitude, latitude])
                        this.currentMarker.addTo(this.map)
                    }
                    this.inThere = inThere
                }
            }, err => {
                console.log(err)
            }, {timeout: 20000, enableHighAccuracy: true})
        },
        handleOrientation (res) {
            const alpha = res.webkitCompassHeading
            // console.log('获取到的数据', alpha)
            // alert(`收到数据alpha: ${alpha}`)
            this.alpha = alpha
            this.deviceOrientationHandler(alpha)
        },
        handleOrientationAbsolute (res) {
            const alpha = 360 - res.alpha
            // console.log('获取到的数据', alpha)
            // alert(`收到数据alpha: ${alpha}`)
            this.alpha = alpha
            this.deviceOrientationHandler(alpha)
        },
        deviceOrientationHandler (alpha) {
            // console.log('收到的角度', alpha)
            if (!this.currentMarker) return
            console.log('有marker')
            const marker = document.querySelector('.current-marker .circle')
            // console.log('当前的marker', marker)
            marker.style.transform = `rotateZ(${alpha - this.bearing}deg)`
        },
        // 修改layer opactiy
        changeOpacity () {
            const zoom = this.map.getZoom()
            console.log(zoom)
            const data = this.calcData(zoom)
            if (this.map.getLayer(this.oldLayer)) {
                this.map.setPaintProperty(this.oldLayer, 'icon-opacity', data.opacity)
                this.map.setLayoutProperty(this.oldLayer, 'icon-size', data.size)
            }
        },
        // 添加当前位置marker
        drawCurrentMarker (longitude, latitude) {
            // add marker to map
            this.showLocateMarker = true
            const marker = new mapboxgl.Marker(this.$refs.marker)
                .setLngLat([longitude, latitude])
                .addTo(this.map)
            this.currentMarker = marker
        },
        // 计算[sw, ne]
        calcLonLat () {
            let minLon = this.list[0].lon
            let minLat = this.list[0].lat
            let maxLon = this.list[0].lon
            let maxLat = this.list[0].lat
            this.list.forEach(item => {
                if (item.lon < minLon) {
                    minLon = item.lon
                } else if (item.lon > maxLon) {
                    maxLon = item.lon
                }
                if (item.lat < minLat) {
                    minLat = item.lat
                } else if (item.lat > maxLat) {
                    maxLat = item.lat
                }
            })
            return [[minLon, minLat], [maxLon, maxLat]]
        },
        // 点击按钮定位到当前位置
        locateUser () {
            if (!this.inThere) {
                const text = '亲，你的当前位置不在圣淘沙'
                this.toast = this.$createToast({
                    time: 1500,
                    type: 'txt',
                    txt: text
                })
                this.toast.show()
                return
            }
            if (this.startGeo && this.startGeo.lon) {
                if (!this.currentMarker) {
                    this.drawCurrentMarker(this.startGeo.lon, this.startGeo.lat)
                }
                this.map.panTo([this.startGeo.lon, this.startGeo.lat])
            } else {
                this.toast = this.$createToast({
                    time: 1500,
                    type: 'txt',
                    txt: '未获取到你的位置，请稍后重试！'
                })
                this.toast.show()
            }
        },
        // 查看景点详情
        handleDetail () {
            switch (this.popupDetail.type) {
                case 'site':
                    window.wx.miniProgram.navigateTo({
                        url: `/packageTourGuide/site/siteDetailPage/index?id=${this.popupDetail.id}`
                    })
                    break
                case 'merchant':
                    window.wx.miniProgram.navigateTo({
                        url: `/packageTourGuide/otherPOI/restaurantDetailPage/index?id=${this.popupDetail.id}`
                    })
                    break
                case 'show_item':
                    window.wx.miniProgram.navigateTo({
                        url: `/packageTourGuide/show/showDetailPage/index?id=${this.popupDetail.id}`
                    })
                    break
                case 'site_shop':
                    window.wx.miniProgram.navigateTo({
                        url: `/packageTourGuide/otherPOI/mallDetailPage/index?id=${this.popupDetail.id}`
                    })
                    break
                case 'site_activity':
                    window.wx.miniProgram.navigateTo({
                        url: `/packageTourGuide/site/eventDetailPage/index?id=${this.popupDetail.id}`
                    })
                    break
                default:
                    break
            }
        },
        // 开始滑动
        handleTouchStart(e) {
            if (this.inTransition) {
                return
            }
            console.log('开始滑动', e.touches[0].clientY)

            this.hold = true
            this.startY = e.touches[0].clientY
            this.lastTouch = {
                y: e.touches[0].clientY,
                t: Date.now()
            }
        },
        // 滑动中
        handleTouchMove(e) {
            if (this.inTransition) {
                return
            }
            if (!this.hold) {
                return
            }

            const offsetY = e.touches[0].clientY - this.lastTouch.y
            const now = Date.now()
            const speed = (offsetY / (now - this.lastTouch.t)) * 1000
            const windowHeight = window.innerHeight
            this.translateY = _clamp(this.translateY + offsetY, 140 - 0.5 * windowHeight, 0.5 * windowHeight - this.triggerHeight)
            this.speed = speed
            this.lastTouch = {
                y: e.touches[0].clientY,
                t: now
            }
        },
        handleNavEnd () {
            this.hold = false
        },
        // 滑动结束
        handleTouchEnd() {
            console.log(this.inTransition, this.hold)
            if (this.inTransition) {
                return
            }
            if (!this.hold) {
                return
            }
            const windowHeight = window.innerHeight
            const bounds = this.list.length > 0 ? this.calcLonLat() : []

            this.hold = false

            if (this.translateY === 0.5 * windowHeight - this.triggerHeight) {
                this.toBottom(0)
                if (this.list.length > 0) {
                    this.map.fitBounds(bounds, {
                        padding: {
                            top: 30,
                            bottom: this.triggerHeight + 30,
                            left: 60,
                            right: 60
                        }
                    })
                }
                return
            } else if (this.translateY === 140 - 0.5 * windowHeight) {
                this.toTop(0)
                if (this.list.length > 0) {
                    this.map.fitBounds(bounds, {
                        padding: {
                            top: 30,
                            bottom: windowHeight - 140 + 30,
                            left: 60,
                            right: 60
                        }
                    })
                }
                return
            }
            this.inTransition = true

            this.$nextTick(() => {
                console.log("speed", this.speed)
                console.log('translateY', this.translateY)
                if (this.speed > 0) {
                    console.log('下滑', this.triggerHeight)
                    // 下滑
                    if (this.translateY > 40) {
                        this.toBottom(300)
                    } else if (this.translateY > 140 - 0.5 * windowHeight && this.translateY <  20) {
                        this.toMiddle(300)
                    } else {
                        this.toTop(300)
                    }
                } else {
                    console.log('上滑')
                    // 上滑
                    if (this.translateY > 0 && this.translateY < 30) {
                        this.toBottom(300)
                    } else if (this.translateY < -110) {
                        this.toTop(300)
                    } else {
                        this.toMiddle(300)
                    }
                }
                console.log('最新距离底部高度', this.boundBottom)
                if (this.list.length > 0) {
                    console.log(bounds)
                    this.map.fitBounds(bounds, {
                        padding: {
                            top: 30,
                            bottom: this.boundBottom,
                            left: 60,
                            right: 60
                        }
                    })
                }
            })
        },
        toTop (delay) {
            const windowHeight = window.innerHeight
            this.translateY = 140 - 0.5 * windowHeight
            this.boundBottom = windowHeight - 140 + 30
            setTimeout(() => {
                this.scrollHeight = `calc(100vh - 140px - ${this.triggerHeight}px)`
                this.$nextTick(() => {
                    this.$refs.scroll.refresh()
                })
            }, delay)
        },
        toMiddle (delay) {
            const windowHeight = window.innerHeight
            this.translateY = 0
            this.boundBottom = 0.5 * windowHeight + 30
            setTimeout(() => {
                this.scrollHeight = `calc(50vh - ${this.triggerHeight}px)`
                this.$nextTick(() => {
                    this.$refs.scroll.refresh()
                })
            }, delay)
        },
        toBottom (delay) {
            const windowHeight = window.innerHeight
            this.translateY = 0.5 * windowHeight - this.triggerHeight
            this.boundBottom = this.triggerHeight + 30
            setTimeout(() => {
                this.scrollHeight = `calc(50vh - ${this.triggerHeight}px)`
                this.$nextTick(() => {
                    this.$refs.scroll.refresh()
                })
            }, 300)
        },
        // 关闭详情
        handleClose() {
            this.expand = false
            this.inTransition = true
            this.$nextTick(() => {
                this.translateY = 0
            })
        },
        handleTransitionEnd() {
            console.log('end')
            this.inTransition = false
        },
        handleStop() {},
        handleScroll(e) {
            this.scrollTop = e.y
        }
    }
}
</script>

<style lang="scss" scoped>
#map {
    width: 100%;
    height: 100vh;
}

.around {
    height: 100vh;
    overflow: hidden;
    position: relative;

    &-list {
        position: absolute;
        left: 0;
        right: 0;
        z-index: 12;
        background-color: #ffffff;
        // top: calc(100vh - 446px);
        top: 50vh;
        border-radius: 8px 8px 0 0;

        .move-trigger {
            padding-top: 12px;
        }

        .line {
            width: 24px;
            height: 2px;
            background-color: #dddddd;
            margin: 0 auto 6px;
        }
        &.in-transition {
            transition: all 0.3s ease;
        }

        .tab-nav {
            //width: 100%;
            height: 34px;
            //overflow: hidden;
            display: flex;
            align-items: center;
            //flex-shrink: 0;
            justify-content: space-between;
            //padding: 10rpx 24rpx 26rpx 24rpx;
            //padding: 10rpx 0 26rpx 0;
            padding-bottom: 6px;
            .tab-item {
                position: relative;
                z-index: 1;
                flex-shrink: 0;
                text-align: center;
                //font-weight: 500;
                font-size: 16px;
                color: #888;
                padding: 6px 15px;

                &.active {
                    color: #222215;
                    font-weight: bold;
                    font-family: GothamBold;
                    &::after {
                        transform: scale(1);
                    }
                }
                &::after {
                    position: absolute;
                    z-index: -1;
                    content: "";
                    width: 32px;
                    height: 4px;
                    bottom: 6px;
                    left: 50%;
                    margin-left: -16px;
                    background-color: #f8a909;
                    transition: transform 0.2s ease-out;
                    transform: scale(0);
                }
                &:first-child {
                    padding-left: 18px;
                    &::after {
                    margin-left: -15px;
                    }
                }
                &:last-child {
                    padding-right: 18px;
                    &::after {
                    margin-left: -18rpx;
                    //margin-left: -15rpx;
                    }
                }
            }
        }

        .down-loading{
            height: 37px;
            .no-more{
                width: 100%;
                font-size: 14px;
                color: #888;
                text-align: center;
            }
        }
    }

    .current-locate {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 30;
        position: absolute;
        right: 18px;
        bottom: 100%;
        margin-bottom: 18px;
        z-index: 10;

        img {
            width: 25px;
            height: 26px;
        }
    }

    .empty-tip{
        width:100%;
        padding-top: 30px;
        img{
            width: 200px;
            display: block;
            margin: 0 auto 20px;
        }
        .text{
            width: 208px;
            color: #d8d8d8;
            text-align: center;
            font-size: 16px;
            line-height: 1.5;
            margin: 0 auto;
        }
    }

    .current-marker {
        z-index: 20;
        transform: translate(-9999px, -9999px);
        .circle {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background: url('/image/navigate/current-marker.svg') no-repeat center center;
            z-index: 2;
            position: relative;
            background-size: 100% 100%;
        }

        .arrow {
            position: absolute;
            border: 5px solid transparent;
            border-bottom: 5px solid #00AAE5;
            bottom: 100%;
            left: 50%;
            margin-left: -5px;
            margin-bottom: -2px;
            // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        }
    }
}
</style>